module.exports = __webpack_public_path__ + "img/IMG-20200911-WA0003.12092f9c.jpg";